module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-32x9-e852c21d1d444a71aa3a18549efb8dbf.jpg";